/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const GET_MY_ASSETS = gql`
query Query($auth: WalletAuth!, $input: GetMyAssetsInput) {
    getMyAssets(auth: $auth, input: $input) {
      data {
        _id
        token_id
        title
        subtitle
        serialNo
        type
        tokenGroup
        tag
        img
        category,
        tx_id,
        
        price {
          type
          amount
          currency
          sale {
            salePrice
            saleEndDate
          }
          symbol
        }
        scAddress
        networkType
        media {
          type
          src
          thumbnail
        }
        state
      }
      total
    limit
    skip
    }    
  }
  `;